import {NgModule} from '@angular/core';
import {Mdl} from './mdl.directive';
import {MdlOnRouteChange} from './mdl-on-route-change.directive';

@NgModule({
    declarations: [Mdl, MdlOnRouteChange],
    exports: [Mdl, MdlOnRouteChange]
})
export class CovanceMaterialModule {}